export const FilterJobSection = () => {
  const filtersBtns = document.querySelectorAll('.filters_tag_component .item-list li a')

  if (filtersBtns?.length) {
    filtersBtns.forEach((filter) => {
      filter.addEventListener('click', (e) => {
        e.preventDefault()
        const allSections = document.querySelectorAll('.job_section')
        const termId = filter.dataset.term

        if (allSections?.length) {
          if (filter.classList.contains('active')) {
            allSections.forEach((section) => {
              section.classList.remove('hide')
            })

            filtersBtns.forEach((filter) => {
              filter.classList.remove('active')
            })
          } else {
            filtersBtns.forEach((filter) => {
              filter.classList.remove('active')
            })
            filter.classList.add('active')
            allSections.forEach((section) => {
              section.classList.add('hide')
            })

            if (termId) {
              const sectionToShow = document.querySelector(`.job_section[data-term=${termId}]`)
              sectionToShow.classList.remove('hide')
            }
          }
        }
      })
    })
  }
}
